import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { TableFilterComponent } from "../table-filter/table-filter.component";

@Component({
  selector: "app-table-search",
  templateUrl: "./table-search.component.html",
  styleUrls: ["./table-search.component.scss"],
})
export class TableSearchComponent<T extends object> implements OnInit {
  @Input() options: string[] = [];
  @ViewChild(TableFilterComponent)
  tableFilterComponent?: TableFilterComponent<T>;

  form: FormGroup;

  constructor() {
    this.form = new FormGroup({
      searchBy: new FormControl(""),
      searchFor: new FormControl(""),
    });

    this.form.get("searchBy")?.valueChanges.subscribe((val) => {
      if (this.tableFilterComponent && this.tableFilterComponent.form) {
        this.tableFilterComponent.form.get("text")?.reset("");
      }
    });
  }

  ngOnDestroy() {
    this.form.reset();
  }
  

  ngOnInit(): void {}
}
